import {_request, _requestForm} from "./api";


export const add = (data) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (data,registration_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `registration/${registration_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (documents_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `registration/${documents_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration', method: 'GET', params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listItem = (registration_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration/item/'+String(registration_guid), method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listPlayers = (registration_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration/free-players-registration/' + String(registration_guid), method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const addItem = (data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration/item', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const removeItem = (registration_players_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'registration/item/'+String(registration_players_guid), method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const processRegistration = (documents_guid, data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: `registration/process-document/${documents_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

